import { getApi } from "./api_instance";

export const getProjectDetails = async (projectId, dispatch) => {
  try {
    return await getApi({
      apiUrl: `/projects/api/${projectId}`,
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
